import { render, staticRenderFns } from "./MitManageReservationsPage.vue?vue&type=template&id=70bb97ae&scoped=true"
import script from "./MitManageReservationsPage.vue?vue&type=script&lang=js"
export * from "./MitManageReservationsPage.vue?vue&type=script&lang=js"
import style0 from "./MitManageReservationsPage.vue?vue&type=style&index=0&id=70bb97ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb97ae",
  null
  
)

export default component.exports